import { useSession } from '../lib/session';
import { AdminDashboard } from './dashboard/AdminDashboard';
import { CustomDashboard } from './dashboard/CustomDashboard';
import { ProductionDashboard } from './dashboard/ProductionDashboard';
import { QualityDashboard } from './dashboard/QualityDashboard';
import { resolveDashboardPreset } from './dashboard/presets';
import { ViewerDashboard } from './dashboard/ViewerDashboard';
import { WarehouseDashboard } from './dashboard/WarehouseDashboard';

/**
 * The dashboard, tailored to the workspace being shown.
 *
 * The choice of preset is presentation, exactly like a role's sections: it
 * decides which work a workspace puts first. It is not a permission — every
 * action inside is gated on a capability the API enforces, and a custom role is
 * composed from the capabilities it actually holds rather than from its name.
 */
export function DashboardPage() {
  const { activeRole, capabilities } = useSession();
  const preset = resolveDashboardPreset(activeRole?.code ?? null, capabilities);

  switch (preset) {
    case 'warehouse':
      return <WarehouseDashboard />;
    case 'production':
      return <ProductionDashboard />;
    case 'quality':
      return <QualityDashboard />;
    case 'admin':
      return <AdminDashboard />;
    case 'custom':
      return <CustomDashboard />;
    case 'viewer':
    default:
      return <ViewerDashboard />;
  }
}
